const siteHeader = document.getElementById('siteHeader');
const contentContainer = document.querySelector('main article');
const menuToggle = document.getElementById('menuToggle');
const navigation = document.querySelector('.site-header__nav');
const activeMenuItem = document.querySelector('.current-menu-item');
const menuUvDot = document.querySelector('.menu-uv-dot');

if (siteHeader && contentContainer) {
	// Menu toggle
	if (menuToggle) {
		menuToggle.addEventListener('click', () => {
			if (siteHeader.classList.contains('active')) {
				siteHeader.classList.remove('active');
				document.querySelector('body').style.overflow = 'visible';
				setTimeout(() => {
					navigation.style.zIndex = -10;
				}, 400);
			} else {
				siteHeader.classList.add('active');
				document.querySelector('body').style.overflow = 'hidden';
				setTimeout(() => {
					navigation.style.zIndex = 99;
				}, 40);
			}
		});

		//  Esc to close menu
		document.addEventListener('keydown', function (event) {
			if (siteHeader.classList.contains('active') && event.key === 'Escape') {
				siteHeader.classList.remove('active');
			}
		});
	}

	// Active UV dot
	if (activeMenuItem) {
		const activeMenuItemPos = activeMenuItem.getBoundingClientRect();

		menuUvDot.style.left = `${activeMenuItemPos.x}px`;
		menuUvDot.style.top = `${activeMenuItemPos.y - menuUvDot.offsetWidth / 2}px`;

		window.addEventListener('resize', () => {
			const activeMenuItemPos = activeMenuItem.getBoundingClientRect();

			menuUvDot.style.left = `${activeMenuItemPos.x}px`;
			menuUvDot.style.top = `${activeMenuItemPos.y - menuUvDot.offsetWidth / 2}px`;
		});
	} else {
		menuUvDot.style.opacity = '0';
	}

	window.addEventListener('resize', () => {
		if (window.innerWidth > 1200) {
			navigation.style.zIndex = 99;
		} else {
			navigation.style.zIndex = -10;
		}

		// Reset menu on resize
		if (siteHeader.classList.contains('active')) {
			siteHeader.classList.remove('active');
			document.querySelector('body').style.overflow = 'visible';
			setTimeout(() => {
				navigation.style.zIndex = -10;
			}, 400);
		}
	});
}
